// extracted by mini-css-extract-plugin
export var textarea = "textarea-module--textarea--Ouu2O";
export var textarea_label = "textarea-module--textarea_label--u4v3r";
export var textarea_input = "textarea-module--textarea_input--CL8Fo";